module.exports = __webpack_public_path__ + "static/media/bannerEenf.4ea61444.jpg";